import { MapPin, MessageCircle } from "lucide-react";
import { PublicPage, H2, P } from "@/components/PublicPage";
import { BUSINESS, waLink } from "@/lib/site";

export default function About() {
  return (
    <PublicPage testid="about-page" overline="Tentang Kami" title="Tentang Mas Tofa AI">
      <P>
        Mas Tofa AI adalah layanan berbasis AI yang dirancang untuk membantu pengguna membuat
        materi pemasaran dan video produk dengan lebih efisien. Produk utama kami saat ini adalah
        <strong> Video Jualan AI</strong>: Anda mengunggah foto produk dan informasi produk, lalu
        AI membantu menyiapkan konsep serta videonya.
      </P>
      <P>
        Tujuan kami sederhana — membuat proses pembuatan konten promosi menjadi lebih mudah dan
        cepat bagi penjual online, UMKM, pemilik toko, dan pelaku pemasaran digital.
      </P>

      <H2>Cara Kerja Singkat</H2>
      <P>Unggah foto produk → masukkan informasi produk → AI membantu membuat video jualan. Setiap
        pembuatan video menggunakan kredit pada akun Anda.</P>

      <H2>Informasi Bisnis</H2>
      <div className="rounded-xl border border-slate-200 bg-white p-6">
        <p className="font-heading font-semibold text-slate-900">{BUSINESS.name}</p>
        <div className="mt-3 flex items-start gap-2 text-sm text-slate-600">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" />
          <span>{BUSINESS.address.line1}, {BUSINESS.address.line2}, {BUSINESS.address.line3}</span>
        </div>
        <a href={waLink()} target="_blank" rel="noopener noreferrer"
          className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:underline" data-testid="about-whatsapp">
          <MessageCircle className="h-4 w-4" /> WhatsApp Admin: {BUSINESS.whatsappDisplay}
        </a>
      </div>
    </PublicPage>
  );
}
